import { render, staticRenderFns } from "./PurpleButton.vue?vue&type=template&id=786a64bc&scoped=true&"
import script from "./PurpleButton.vue?vue&type=script&lang=js&"
export * from "./PurpleButton.vue?vue&type=script&lang=js&"
import style0 from "./PurpleButton.vue?vue&type=style&index=0&id=786a64bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786a64bc",
  null
  
)

export default component.exports